/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';

import { Button, Grid, makeStyles, Typography } from '@material-ui/core';

import CaseActionsArchiveButton from './CaseActionsArchiveButton';

const useStyles = makeStyles(() => {
  return {
    sectionHeader: {
      color: '#172B4D',
      fontSize: '18px',
      fontWeight: 'bold',
      marginBottom: '1rem',
    },
    sectionText: {
      color: '#999999',
      fontSize: '12px',
      marginTop: '1rem',
    },
  };
});

export default ({ onCaseAction, auth, isArchiving$ }) => {
  const classes = useStyles();

  return (
    <Grid container direction="column" style={{ height: '100%', textAlign: 'left' }}>
      <Grid item container>
        <Grid item>
          <Typography className={classes.sectionHeader}>Complete/Submit Case</Typography>
        </Grid>
        <Grid item>
          <Typography className={classes.sectionText}>
            Additional information is required to submit this case on behalf of the patient. Please provide the required information to submit this case.
          </Typography>
        </Grid>
      </Grid>

      <Grid item style={{ marginTop: '1rem' }}>
        <Grid container spacing={1}>
          <Grid item>
            <Button color="primary" variant="contained" size="large" onClick={() => onCaseAction('complete')}>
              Complete Case
            </Button>
          </Grid>
          <Grid item>
            <CaseActionsArchiveButton auth={auth} isArchiving$={isArchiving$} onCaseAction={onCaseAction} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
